function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { useToastState } from "@react-stately/toast";
import { useStableCallback } from "../../helpers";
import { SnackbarRegion } from "./SnackbarRegion";
const SnackbarContext = /*#__PURE__*/React.createContext(null);
export function useSnackbar() {
  return React.useContext(SnackbarContext);
}
export function SnackbarProvider(_ref) {
  let {
    children,
    maxVisibleSnackbars = 1,
    placement = "bottom-left"
  } = _ref;
  const state = useToastState({
    maxVisibleToasts: maxVisibleSnackbars
  });

  // Snackbar state.add and state.remove are not stable due to https://github.com/adobe/react-spectrum/discussions/7481
  // Discussions:
  // -> Slack - https://taxify.slack.com/archives/C034P1EFKDF/p1701343973490099
  // -> Jira - https://taxify.atlassian.net/browse/KALEP-613
  const stableAdd = useStableCallback(state.add);
  const stableRemove = useStableCallback(state.remove);
  const stableClose = useStableCallback(state.close);
  const stablePauseAll = useStableCallback(state.pauseAll);
  const stableResumeAll = useStableCallback(state.resumeAll);
  const memoizedState = React.useMemo(() => _objectSpread(_objectSpread({}, state), {}, {
    add: stableAdd,
    remove: stableRemove,
    close: stableClose,
    pauseAll: stablePauseAll,
    resumeAll: stableResumeAll
  }), [stableAdd, stableRemove, stableClose, stablePauseAll, stableResumeAll, state]);
  return /*#__PURE__*/React.createElement(SnackbarContext.Provider, {
    value: memoizedState
  }, typeof children === "function" ? children(state) : children, state.visibleToasts.length > 0 && /*#__PURE__*/React.createElement(SnackbarRegion, {
    state: state,
    placement: placement
  }));
}